const OrdersRouter = {
  path: '/orders',
  component: () => import('@/layout'),
  redirect: '/orders/customer-list',
  name: 'Orders',
  meta: {
    title: '订单管理',
    icon: 'el-icon-document'
  },
  children: [
    {
      path: 'customer-list',
      component: () => import('@/views/orders/customer-orders-list'),
      name: 'CustomerOrdersList',
      meta: { title: '客户订单', icon: 'el-icon-s-custom' }
    },
    {
      path: 'supplier-list',
      component: () => import('@/views/orders/supplier-orders-list'),
      name: 'SupplierOrdersList',
      meta: { title: '供应商订单', icon: 'el-icon-s-shop' }
    },
    {
      path: 'detail/:id',
      component: () => import('@/views/orders/supplier-order-detail'),
      name: 'OrderDetail',
      meta: { title: '订单详情', icon: 'el-icon-document' },
      hidden: true
    },
    {
      path: 'distribute/:id',
      component: () => import('@/views/orders/orders-distribute'),
      name: 'OrderDistribute',
      meta: { title: '订单分发', icon: 'el-icon-share' },
      hidden: true
    },
    {
      path: 'supplier-order-detail/:id',
      component: () => import('@/views/orders/supplier-order-detail'),
      name: 'SupplierOrderDetail',
      meta: { title: '供应商订单详情', icon: 'el-icon-document' },
      hidden: true
    },
    {
      path: 'customer-order-detail/:id',
      component: () => import('@/views/orders/customer-order-detail'),
      name: 'CustomerOrderDetail',
      meta: { title: '客户订单详情', icon: 'el-icon-document' },
      hidden: true
    },
    {
      path: 'shipment/:orderId',
      component: () => import('@/views/orders/order-shipment'),
      name: 'OrderShipment',
      meta: { title: '订单发货', icon: 'el-icon-truck' },
      hidden: true
    },
    {
      path: 'return/:orderId',
      component: () => import('@/views/orders/order-return'),
      name: 'OrderReturn',
      meta: { title: '订单退货', icon: 'el-icon-refresh-left' },
      hidden: true
    }
  ]
}

export default OrdersRouter 